/* eslint-disable no-magic-numbers */

const RETRY_STATUS_CODES = [500];
const RETRY_COUNT = 1;

export const isServer = () => {
    return typeof window === 'undefined';
};

export const getErrorMetadataObject = (actionObj, prevMetaData = {}) => {
    const { failedCount = 0 } = prevMetaData;
    const { statusCode } = actionObj;

    return {
        isSSRError: isServer(),
        failedCount: failedCount + 1,
        statusCode
    };
};

export const shouldRetry = errorMetadataObject => {
    if (
        !isServer()
        && errorMetadataObject
        && errorMetadataObject.isSSRError
        && RETRY_STATUS_CODES.includes(errorMetadataObject.statusCode)
        && (errorMetadataObject.failedCount <= RETRY_COUNT)
    ) {
        return true;
    }

    return false;
};
